import { Api } from './index';

export const fetchCms = () => Api.get('/cms');

export const fetchPopups = () => Api.get('/cms/popups');
